export const paginationOnEndReach = (e, func) => {
  const bottom =
    e.target.scrollHeight - e.target.scrollTop - 50 <= e.target.clientHeight;
  if (bottom) {
    func();
  }
};
